import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
    name: 'driverSettingType',
    initialState: {
        isRequesting: false,
        error: null,
        data: [],
        total: 0,
        searchCriteria: {},
    },
    reducers: {
        get_list: (state, action) => {
            return {
                ...state,
                isRequesting: true,
                error: null,
                searchCriteria: { ...action.payload },
            };
        },
        get_list_succeed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                data: action.payload.items,
                total: action.payload.total,
            };
        },
        get_list_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: action.payload.error,
                data: [],
            };
        },
        reset_data: (state) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                data: [],
                total: 0,
                searchCriteria: {},
            };
        },
        create_driver_setting_type: (state) => {
            return {
                ...state,
                isRequesting: true,
                isDone: false,
                error: null,
            };
        },
        create_driver_setting_type_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                isDone: true,
                error: action.payload,
            };
        },
        create_driver_setting_type_succeed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                isDone: true,
                data: action.payload,
            };
        },
        delete_driver_setting_type: (state) => {
            return {
                ...state,
                isRequesting: true,
                isDone: false,
                error: null,
            };
        },
        delete_driver_setting_type_success: (state) => {
            return {
                ...state,
                isRequesting: false,
                isDone: true,
                error: null,
            };
        },
        delete_driver_setting_failed: (state) => {
            return {
                ...state,
                isRequesting: false,
                isDone: true,
                error: null,
            };
        },
    },
});

export const { reducer, actions } = slice;

export default reducer;
